import { render, staticRenderFns } from "./OlvideContrasena.vue?vue&type=template&id=1ff94b72&"
import script from "./OlvideContrasena.vue?vue&type=script&lang=js&"
export * from "./OlvideContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports